define("shared/modifiers/autofocus", ["exports", "ember-modifier"], function (_exports, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier"eaimeta@70e063a35619d71f

  var _default = (0, _emberModifier.modifier)((element, params) => {
    // focus unless explicitly set to false
    if (params[0] !== false) {
      element.focus();
    }
  });

  _exports.default = _default;
});